import PrintBox from './PrintBox.view';

export default PrintBox;
